export default "__VITE_ASSET__DGPbCc3x__"